import { render } from "./ReceiptQuery.vue?vue&type=template&id=8ddfff2a&scoped=true"
import script from "./ReceiptQuery.vue?vue&type=script&lang=js"
export * from "./ReceiptQuery.vue?vue&type=script&lang=js"

import "./ReceiptQuery.vue?vue&type=style&index=0&id=8ddfff2a&lang=less&scoped=true"

import exportComponent from "/root/workspace/school-mobile_yvTP/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ddfff2a"]])

export default __exports__